import { enUS, nlNL } from '@mui/x-data-grid/locales';
import i18n from '../../../localization/i18next';
export function getDataGridLocaleText() {
    var language = i18n.language;
    switch (language) {
        case 'en':
            return enUS.components.MuiDataGrid.defaultProps.localeText;
        case 'nl':
            return nlNL.components.MuiDataGrid.defaultProps.localeText;
        default:
            return enUS.components.MuiDataGrid.defaultProps.localeText;
    }
}
